<template>
	<div class="row m-0">
		<div class="col-lg-12">
			<div class="sec-maker-header text-center">
				<span class="sec-maker-span-text">
					<i class="fa fa-info-circle"></i>Today's Discount</span
				>
				<h3 class="sec-maker-h3 u-s-m-b-22">Upto 50% off on Sonoff Basic today. T&C Apply.</h3>
			</div>
		</div>
	</div>
</template>

<script>
	export default {};
</script>

<style></style>
